import { Box, BoxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Paper } from 'shared/ui/Paper';
import { Category } from 'widgets/startRecognition/consts/CategoryList';

interface Props extends BoxProps {
	category: Category;
	action?: () => void;
}

export const CategoryCard: FC<Props> = ({ sx, category, action }) => {
	const { t } = useTranslation();

	return (
		<Paper
			onClick={() => action && action()}
			sx={{
				'position': 'relative',
				'padding': '20px 30px',
				'backgroundColor': ColorPalette.white,
				'boxShadow': 'none',
				'borderRadius': '20px',
				'display': 'flex',
				'flexDirection': 'row',
				'transition': 'all .3s',
				'border': `1px solid ${ColorPalette.white}`,
				'cursor': action ? 'pointer' : 'inherit',
				'&:hover': {
					border: `1px solid ${action ? ColorPalette.royalBlue : ColorPalette.white}`,
				},
				'& .MuiButtonBase-root': {
					opacity: 0,
					transition: 'all .3s',
				},
				'&:hover .MuiButtonBase-root': {
					opacity: action ? 1 : 0,
				},
				'width': '100%',
				...sx,
			}}
		>
			<img
				src={category.img}
				alt={category.id}
				style={{ width: '82px', height: '82px', marginRight: '26px', alignSelf: 'center' }}
			/>
			<Box sx={{ overflow: 'hidden' }}>
				<Typography
					variant={'subtitle1'}
					color={ColorPalette.astronaut}
					sx={{
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{t(category.label)}
				</Typography>
				{category.description && (
					<Typography variant={'body2'} color={ColorPalette.rockBlue} sx={{ marginTop: '10px' }}>
						{t(category.description)}
					</Typography>
				)}
			</Box>
		</Paper>
	);
};
